// Pure helpers for the Show toggle. A missing `visible` flag means visible.

export const allVisibleUpdates = (parts) =>
  parts
    .filter(part => part.visible === false)
    .map(part => ({ id: part.id, visible: true }));

export const myPartOnlyUpdates = (parts, me) =>
  parts
    .filter(part => (part.visible !== false) !== (part.id === me))
    .map(part => ({ id: part.id, visible: part.id === me }));

// 'all' | 'mine' | 'custom'. A single-part score reads as 'all'.
export const visibilityMode = (parts, me) => {
  if (parts.every(part => part.visible !== false)) return 'all';
  const hasMe = me !== null && me !== undefined;
  if (hasMe && parts.every(part => (part.visible !== false) === (part.id === me))) {
    return 'mine';
  }
  return 'custom';
};
